
// /**
//  * 事件上报
//  * @param {Object} sensors
//  * @param {String} event 事件名称
//  * @param {Object} params 属性对象
//  */
// export function track(sensors, event, params) {
//   if (params && params.length) {
//     params.forEach((item) => {
//       var data = JSON.parse(item)
//       // console.log(event,data)
//       sensors.track(event, data)
//     })
//   }
// }

/**
 * 事件上报
 * @param {Object} sensors
 * @param {Object} dataArr 属性对象，dataArr结构： {event: 事件名, value: 属性对象的json字符串}
 */
export function track(sensors, dataArr) {
  if (dataArr && dataArr.length) {
    dataArr.forEach((item) => {
      // console.log(event,data)
      sensors.track(item.event, JSON.parse(item.value))
    })
  }
}
